export const DEBOUNCE_TIMES = {
  NUMBER_INPUT: 600,
  STRING_INPUT: 800,
  CART_API: 300,
  SEARCH_DEBOUNCE: 300,
  SAFARI_CART_DELAY: 400,
}; // milliseconds
